import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Header/Header';

const Details = () => {
  const navigation = useNavigate();
  const { id } = useParams();
  const [project, setProject] = useState([]);
  const { picture, heading, subtitle, detail, technology, live } = project;

  useEffect(() => {
    const url = "database.json/service" + { id };
    fetch(url)
      .then((res) => res.json())
      .then((data) => setProject(data));
  }, []);
  return (
    <div className="mx-12">
      <button
        onClick={() => navigation('/')}
        className=" mt-5 btn btn-primary text-white"
      >
        ← Back to Home
      </button>
      <div>
        <div></div>
        <div>
          <div class="hero min-h-screen ">
            <div class="hero-content flex-col lg:flex-row">
              <img src={picture} class="max-w-sm rounded-lg shadow-2xl" />
              <div>
                <h1 class="text-5xl font-bold">{heading}</h1>
                <h4>{subtitle} </h4>
                <p class="py-6">{detail}</p>

                <p className='text-xl'>Technology Use : <span className='text-white'>{technology}</span> </p>

                <div className="flex items-center">
                  <a href={live} target="_blank">
                    <button class="btn btn-primary mt-8">Live Preview</button>
                  </a>
                  <div class="divider lg:divider-horizontal"></div>
                  <a href="https://github.com/shahidul7150" target="_blank">
                    <button class="btn btn-primary mt-8">
                      check github profile
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
